import { useState, useEffect } from 'react';
import { api } from '@/lib/api-client';
import { Download } from 'lucide-react';
import { toast } from '@/components/ui/sonner';

export default function Invoices() {
  const [invoices, setInvoices] = useState([]);
  useEffect(() => { api.getInvoices().then(setInvoices); }, []);

  return (
    <div data-testid="invoices-page" className="space-y-6">
      <h1 className="text-2xl font-bold text-white font-mono">Invoices</h1>
      <div className="bg-[#0A0A0A] border border-zinc-800 rounded-sm overflow-hidden">
        <table className="w-full">
          <thead><tr className="border-b border-zinc-800">
            {['Invoice', 'Date', 'Plan', 'Amount', 'Status', 'PDF'].map(h => (
              <th key={h} className="text-left py-3 px-4 text-xs font-mono text-zinc-500 uppercase tracking-widest">{h}</th>
            ))}
          </tr></thead>
          <tbody>
            {invoices.map(inv => (
              <tr key={inv.id} data-testid={`invoice-${inv.id}`} className="border-b border-zinc-800/50 hover:bg-white/[0.02]">
                <td className="py-3 px-4 text-sm font-mono text-white">{inv.id}</td>
                <td className="py-3 px-4 text-sm font-mono text-zinc-400">{inv.date}</td>
                <td className="py-3 px-4 text-sm font-mono text-zinc-400">{inv.plan}</td>
                <td className="py-3 px-4 text-sm font-mono text-white">${inv.amount.toFixed(2)}</td>
                <td className="py-3 px-4"><span className="bg-emerald-500/10 text-emerald-400 text-xs font-mono px-2 py-0.5 rounded-sm">{inv.status}</span></td>
                <td className="py-3 px-4"><button data-testid={`download-${inv.id}`} onClick={() => toast.success(`Invoice ${inv.id} downloaded`)} className="text-zinc-500 hover:text-emerald-400 transition-colors"><Download size={14} /></button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
